
import React from "react";
import { Container, Row, Card, Col, CardHeader, CardBody, CardText, Button } from "reactstrap";
import BackButton from "../BackButton/BackButton";
import '../../assets/css/dcg-page.css';
import { useAPIContext } from "../../utilities/Contexts/DCGAutomationPagesContextProvider";
import { isAutomationCompleted } from "../../utilities/getAutomationDataFromLocalStorage";


function HeaderAndBodyLayout({ headerLogo, children, containerSize = 'sm', backButton = true }) {
    const { isFinalConfirmationPage } = useAPIContext();
    let showPage = !isAutomationCompleted();
    if (isFinalConfirmationPage) {
        showPage = true;
    }
    let showBackButton = backButton;
    if (!showPage) {
        showBackButton = false;
    }
    return (
        <Container className="dcg-automation-pages">
            <Row className="justify-content-center"> {/* Centers the row horizontally */}
                <Col md={size[containerSize]}> {/* Sets the width of the card, change md value as needed */}
                    <Card className="mx-auto my-2"> {/* Automatically centers the card */}
                        <CardHeader className="bg-primary">
                            <div style={containerStyle}>
                                {showBackButton && <div style={leftTextStyle}><BackButton label="Back" /></div>}
                                <div style={centerTextStyle}><img src={headerLogo} alt="dcg logo" /></div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            {showPage && children}
                            {!showPage && <h3 style={{textAlign: 'center'}}>You have successfully completed onboarding</h3>}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

const size = {
    lg: '12',
    md: '8',
    sm: '6'
};

//styles
const containerStyle = {
    display: 'flex',
    justifyContent: 'space-between',   // Makes left and right text stay at the ends
    alignItems: 'center',              // Vertically aligns text in the middle
    position: 'relative',
    height: '43px'
};

const leftTextStyle = {
    marginLeft: '10px',
};

const centerTextStyle = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',     // Centers the text horizontally
    textAlign: 'center',
};


export default HeaderAndBodyLayout
